import * as React from "react";
import { Button, Space, Tooltip } from "antd";
import { CardContent } from "../../../components/antd/card/CardContent";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpSwitch } from "../../gvc/testNewForm/CpSwitch";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";

interface Props {}
export const SecretDataUserpass: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const isPasswordVisible = useCpFormValue(`userpass.password.isVisible`);

  return (
    <>
      <CardContent>
        <div style={{ maxWidth: 600 }}>
          <CpFormItem>
            <CpLabel name={`userpass.username`}>Username</CpLabel>
            <CpInput name={`userpass.username`} />
            <CpErrorWarning name={`userpass.username`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`userpass.password.value`}>Password</CpLabel>
            <Space.Compact>
              <CpInput name={`userpass.password.value`} type={isPasswordVisible ? "text" : `password`} />
              <Tooltip title={isPasswordVisible ? "Hide" : "Show"}>
                <Button
                  onClick={() => formSetValue(id, `userpass.password.isVisible`, !isPasswordVisible)}
                  icon={isPasswordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                />
              </Tooltip>
            </Space.Compact>
            <CpErrorWarning name={`userpass.password.value`} />
          </CpFormItem>
          <CpFormItem>
            <div className="flex items-center gap-2">
              <CpLabel name={`userpass.base64Decode`}>Base64 Decode at Runtime</CpLabel>
              <CpSwitch name={`userpass.base64Decode`} />
              <CpTooltip
                tooltipProps={{
                  title: `Checking this box will perform a base64 decode at runtime of the secret content.`,
                }}
              />
            </div>
            <CpErrorWarning name={`userpass.base64Decode`} />
          </CpFormItem>
        </div>
      </CardContent>
    </>
  );
};
